/**
 * BackToPreviousTab — pill „← Wróć do {nazwa poprzedniej zakładki}"
 * pokazywany na górze każdego modułu (oprócz startowego).
 *
 * Śledzi poprzednią zakładkę przez useRef + useEffect na zmianę activeTab.
 * Klik → setActiveTab(previous).
 *
 * Wymaga: activeTab, setActiveTab, tabLabels (map { tabKey: 'Etykieta' }).
 */
import React, { useEffect, useRef } from 'react';

const BackToPreviousTab = ({ activeTab, setActiveTab, tabLabels, defaultTab = 'add' }) => {
  // Ostatnia poprzednia zakładka (różna od aktualnej)
  const prevRef = useRef(null);
  const lastSeenRef = useRef(activeTab);

  useEffect(() => {
    if (activeTab !== lastSeenRef.current) {
      prevRef.current = lastSeenRef.current;
      lastSeenRef.current = activeTab;
    }
  }, [activeTab]);

  // Ukryj na startowej i jeśli brak poprzedniej
  if (activeTab === defaultTab) return null;
  const previous = prevRef.current && prevRef.current !== activeTab ? prevRef.current : defaultTab;
  const label = tabLabels?.[previous] || 'Start';

  return (
    <button
      type="button"
      onClick={() => setActiveTab(previous)}
      data-testid="back-to-previous-tab"
      title={`Wróć do: ${label}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 14px',
        marginBottom: 14,
        background: 'rgba(245, 158, 11, 0.10)',
        color: 'var(--gold)',
        border: '1px solid rgba(245, 158, 11, 0.35)',
        borderRadius: 999,
        cursor: 'pointer',
        fontSize: 13,
        fontWeight: 600,
        fontFamily: 'inherit',
        transition: 'all 0.15s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(245, 158, 11, 0.18)';
        e.currentTarget.style.transform = 'translateX(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(245, 158, 11, 0.10)';
        e.currentTarget.style.transform = 'translateX(0)';
      }}
    >
      <span style={{ fontSize: 14 }}>‹</span>
      <span>Wróć do: <strong>{label}</strong></span>
    </button>
  );
};

export default BackToPreviousTab;
